exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attribute[data-v-20467a51]{height:500px}.attribute[data-v-20467a51] .el-table__body-wrapper{height:90%!important}", ""]);

// exports
